import { IPage } from 'app/app/editor/index.functions';
import { findAllNestedComponentsUid, processPageContainersUid } from 'app/app/editor/page/index';
import { getNodeWithParentByUid } from 'app/app/editor/page/getNodeByUid';

export default function deleteComponentFromPage(scrPage: IPage, uid: string) {
    const newPage = structuredClone(scrPage);
    const node = getNodeWithParentByUid(newPage.layout, uid);
    if (!node) {
        return newPage;
    }

    const componentsToRemove =
        node.node.type == 'component' ? [node.node.params.uid] : findAllNestedComponentsUid(node.node);
    // Remove nested Components from page
    componentsToRemove.forEach((c) => {
        delete newPage.components[c];
    });
    // Remove container from Layout tree;
    node.parentNode.elements?.splice(node.nodeIndex, 1);
    processPageContainersUid(newPage.layout, 'container');
    return newPage;
}
